<template>
	<div>
		<DetailTitle title="조회 기간"></DetailTitle>

		<SearchDateRange
			:start-date="searchStartDate"
			:end-date="searchEndDate"
			@search="search"
		/>

		<DetailCardContainer>
			<ContractListItem
				v-for="item in userContractList"
				:key="item.NUM"
				:item="item"
				@initRender="initRender"
			/>
		</DetailCardContainer>

		<InfiniteLoading
			v-if="isInfiniteLoading"
			ref="infiniteLoading"
			@infinite="infinite"
		/>
	</div>
</template>

<script>
import DetailTitle from '@/components/common/DetailTitle';
import SearchDateRange from '@/components/common/SearchDateRange';
import DetailCardContainer from '@/components/common/DetailCardContainer';
import InfiniteLoading from '@/components/common/InfiniteLoading';
import ContractListItem from './ContractListItem';

import { formatDate } from '@/utils/util';

export default {
	components: {
		DetailTitle,
		SearchDateRange,
		DetailCardContainer,
		InfiniteLoading,
		ContractListItem,
	},
	data() {
		return {
			page: 1,
			startDate: '',
			endDate: '',
			isInfiniteLoading: false,
		};
	},
	computed: {
		limitStartDate() {
			return new Date('2022/01/01');
		},
		searchStartDate() {
			const date = new Date();
			date.setMonth(date.getMonth() - 120);
			return this.limitStartDate.getTime() > date.getTime()
				? this.limitStartDate
				: date;
		},
		searchEndDate() {
			return new Date();
		},
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		userContractList() {
			return this.$store.getters['contractStore/userContractList'];
		},
	},
	created() {
		this.initUserContractList();
	},
	methods: {
		async fetchUserContractList() {
			const payload = {
				userId: this.userId,
				page: this.page,
				startDate: this.startDate,
				endDate: this.endDate,
			};

			return await this.$store.dispatch(
				'contractStore/getUserContractList',
				payload,
			);
		},
		initUserContractList() {
			this.$store.dispatch('contractStore/initUserContractList');
		},
		infinite(state) {
			this.fetchUserContractList().then(({ data }) => {
				if (data.code !== '00000' || data.page > data.totalPage) {
					this.page--;
					state.complete();
				}
				if (data.page <= data.totalPage) {
					this.page++;
					state.loaded();
				}
			});
		},
		setDateRange(date) {
			this.startDate = formatDate(date.start, '');
			this.endDate = formatDate(date.end, '');
		},
		search(date) {
			this.setDateRange(date);

			this.isInfiniteLoading === false
				? (this.isInfiniteLoading = true)
				: this.initRender();
		},
		initRender() {
			this.page = 1;
			this.initUserContractList();
			this.$refs.infiniteLoading.resetInfiniteLoading();
		},
	},
};
</script>

<style scoped>
.search-calender-container {
	display: none;
	position: fixed;
	left: 0;
	right: 0;
	z-index: 5000;
	bottom: 3.75rem;
}

.search-calender-container.is-open {
	display: block;
}
</style>
